<template>
  <div id="configPage">
    <form @submit.prevent="submit" v-if="activeTab === 'gateway'">
      <img id="mp_logo" src="@/assets/MontyPay.png" alt="MontyPay" />
      <!-- <h1>Payment Gateway</h1> -->

      <label class="field">
        <span>Merchant Key</span>
        <input
          required
          v-model="merchantKey"
          type="text"
          placeholder="Configuration Key"
        />
      </label>
      <label class="field">
        <span>Merchant Password</span>
        <input
          required
          v-model="merchantPassword"
          type="text"
          placeholder="Configuration Password"
        />
      </label>

      <!-- Payment Methods Select -->
      <h2>Payment Methods</h2>
      <div id="payment_options">
        <label
          v-for="payment in paymentOptions"
          :key="payment.value"
          class="option"
          :class="{ selected: payment_methods.includes(payment.value) }"
        >
          <input
            type="checkbox"
            :value="payment.value"
            v-model="payment_methods"
            :required="payment_methods.length === 0"
            class="sr-only"
          />
          <span class="dot square"></span>
          <span>{{ payment.label }}</span>

          <img
            v-if="payment.img_url"
            :src="payment.img_url"
            alt=""
            class="icon"
          />
        </label>
      </div>

      <!-- Checkout URL -->
      <label class="field" v-if="showCards">
        <span>Checkout URL</span>
        <select v-model="checkout_url" required>
          <option value="" disabled>Select Checkout URL</option>
          <option v-for="url in checkoutUrls" :key="url" :value="url">
            {{ url }}
          </option>
        </select>
      </label>

      <!-- Wallets -->
      <template v-if="showWallets">
        <h2>Wallets</h2>
        <p class="note">*Only available for Lebanese accounts</p>
        <label class="field">
          <span>API Key</span>
          <input
            required
            v-model="wallet_apiKey"
            type="text"
            placeholder="API Key"
          />
        </label>
        <div id="wallets">
          <label
            v-for="wallet in walletOptions"
            :key="wallet.value"
            class="option"
            :class="{ selected: wallet_brands.includes(wallet.value) }"
          >
            <input
              type="checkbox"
              :value="wallet.value"
              v-model="wallet_brands"
              :required="wallet_brands.length === 0"
              class="sr-only"
            />
            <span class="dot square"></span>
            <img :src="wallet.img_url" :alt="wallet.label" />
            <span>{{ wallet.label }}</span>
          </label>
        </div>
      </template>
      <!-- <div class="sec">
        <label class="dlabel">
          <span class="lbl">Enable Partial Tokenization (With CVV)</span>
          <input
            type="checkbox"
            :checked="with_CVV"
            @change="toggleOption('with_CVV')"
          />
        </label>
        <label class="dlabel">
          <span class="lbl">Enable Full Tokenization (Without CVV)</span>
          <input
            type="checkbox"
            :checked="without_CVV"
            @change="toggleOption('without_CVV')"
          />
        </label>
      </div> -->
      <button id="save" type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ConfigurationPage",
  // props: {
  //   msg: String,
  // },
  data() {
    return {
      errorState: false,
      errorMsg: "",
      loading: true,
      merchantKey: "",
      merchantPassword: "",
      shop: "",
      domain: "",
      config: {},
      session: {},
      with_CVV: false,
      without_CVV: false,
      checkout_url: "",
      checkoutUrls: ["checkout.montypay.com", "check-out.montypay.com"],
      activeTab: "gateway",
      wallet_apiKey: "",

      // Wallet

      // wallet_merchantPassword: "",
      // wallet_config: {},
      // wallet_session: {},
      // wallet_merchantKey: "",
      wallet_brands: [], // e.g. ["WHISH", "OMT_CASH"]
      walletOptions: [
        {
          value: "WHISH",
          label: "WHISH Pay",
          img_url: require("@/assets/whish.png"),
        },
        {
          value: "My_MONTY",
          label: "MyMonty",
          img_url: require("@/assets/mymonty.svg"),
        },
        {
          value: "OMT",
          label: "OMT Pay",
          img_url: require("@/assets/omtpay.png"),
        },
      ],
      paymentOptions: [
        {
          value: "cards",
          label: "Cards",
          img_url: require("@/assets/card.svg"),
        },
        {
          value: "wallets",
          label: "Wallets",
          img_url: require("@/assets/wallet.svg"),
        },
      ],
      payment_methods: [], // "cards" and/or "wallets"
    };
  },
  computed: {
    showCards() {
      return this.payment_methods.includes("cards");
    },
    showWallets() {
      return this.payment_methods.includes("wallets");
    },
    // Stored value: "cards_only" | "wallets_only" | "cards_and_wallets"
    payment_option() {
      if (this.showCards && this.showWallets) return "cards_and_wallets";
      if (this.showCards) return "cards_only";
      if (this.showWallets) return "wallets_only";
      return "";
    },
  },
  methods: {
    async getData(shop, domain) {
      const config = await axios
        .get(`/configuration/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Config:", resp.data);
          return resp.data || {};
        })
        .catch((err) => {
          console.log("Error in getting Config:", err.response.data);
          return {};
        });
      const session = await axios
        .get(`/session/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Session:", resp.data);
          return resp.data || {};
        })
        .catch((err) => {
          console.log("Error in getting Session:", err.response.data);
          return {};
        });

      // const session = await window.session.getSessionByShop(shop || domain);
      this.config = config;
      this.session = session;
      return { config: config, session: session };
    },
    async submit() {
      await axios
        .post("/configuration/update", {
          shop: this.$route.query.shop,
          merchantKey: this.merchantKey,
          merchantPassword: this.merchantPassword,
          with_CVV: this.with_CVV,
          without_CVV: this.without_CVV,
          // Hidden for "Wallets Only"; undefined keeps the saved/default URL
          checkout_url: this.checkout_url || undefined,
          wallet_apiKey: this.wallet_apiKey,
          wallet_brands: this.wallet_brands,
          payment_option: this.payment_option,
        })
        .then((resp) => {
          console.log("Resp:", resp.data);

          window.location.href = resp.data.redirect_url;
        })
        .catch((err) => {
          console.error(err);
          alert("Submition failed");
        });
    },
    toggleOption(option) {
      if (option === "with_CVV") {
        this.with_CVV = !this.with_CVV;
        if (this.with_CVV) this.without_CVV = false; // uncheck the other
      } else if (option === "without_CVV") {
        this.without_CVV = !this.without_CVV;
        if (this.without_CVV) this.with_CVV = false; // uncheck the other
      }
    },
    // Wallet
    async getWalletData(shop, domain) {
      const wallet_config = await axios
        .get(`/wallet/configuration/get?shop=${shop || domain}`)
        .then((resp) => {
          console.log("Wallet Config:", resp.data);
          return resp.data || {};
        })
        .catch((err) => {
          console.log("Error in getting Config:", err.response.data);
          return {};
        });
      this.wallet_config = wallet_config;
      return { wallet_config: wallet_config };
    },
  },
  async mounted() {
    const shop = this.$route.query.shop;
    const domain = this.$route.query.domain;
    if (shop) {
      this.shop = shop;
      this.domain = domain;
      await this.getData(shop, domain);
      this.merchantKey = this.config?.merchantKey || "";
      this.merchantPassword = this.config?.merchantPassword || "";
      this.with_CVV = this.config?.with_CVV || false;
      this.without_CVV = this.config?.without_CVV || false;
      this.checkout_url = this.config?.checkout_url || "";
      this.wallet_apiKey = this.config?.wallet_apiKey || "";
      this.wallet_brands = Array.isArray(this.config?.wallet_brands)
        ? this.config.wallet_brands
        : [];
      const saved = this.config?.payment_option || "";
      this.payment_methods = [
        ...(["cards_only", "cards_and_wallets"].includes(saved)
          ? ["cards"]
          : []),
        ...(["wallets_only", "cards_and_wallets"].includes(saved)
          ? ["wallets"]
          : []),
      ];
    }
  },
  beforeUnmount() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@use "../styles/brand" as *;
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

#configPage {
  min-height: 100dvh;
  width: calc(100vw - 8px);
  box-sizing: border-box;
  // padding: 2rem 1rem;
  background-color: $bg-primary;
  display: flex;
  justify-content: center;
  align-items: center;
  // overflow-x: hidden;

  * {
    background-color: transparent; // App.vue paints every element #f9fafb
    box-sizing: border-box;
    // overflow: hidden;
  }

  form {
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: $white;
    border: 1px solid $light-gray;
    border-radius: 22px;
    padding: 26px;
    overflow-x: hidden;
    margin: 2rem auto;

    #mp_logo {
      height: 50px;
      align-self: flex-start;
    }
    h1 {
      font-size: 28px;
      color: $black;
      margin: 0;
    }
    h2 {
      @include sub-menu();
      margin: 0.5rem 0 0;
    }
    .note {
      @include p();
      margin: 0;
    }

    .field {
      display: flex;
      flex-direction: column;
      gap: 6px;

      span {
        font-size: 12.5px;
        font-weight: 600;
        color: $dark-gray;
      }
      input,
      select {
        @include field-commons();
        width: 100%;
        font-size: 14px;
        color: $black;
        outline: none;

        &:focus {
          border-color: $primary;
        }
      }
    }

    .sr-only {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }
    .option {
      position: relative; // anchors the hidden input's validation bubble
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      background-color: $white;
      border: 1.5px solid $light-gray;
      border-radius: 18px;
      padding: 1rem;
      font-size: 14px;
      color: $black;
      height: 55px;

      &.selected {
        border-color: $primary;
      }
      &:has(.sr-only:focus-visible) {
        outline: 2px solid $primary; // keyboard focus, since the input is hidden
        outline-offset: 2px;
      }
    }
    .dot {
      width: 16px;
      min-width: 16px;
      height: 16px;
      border: 2px solid #999;
      border-radius: 50%;
      transition: all 0.1s ease-in-out;

      &.square {
        border-radius: 5px; // multi-select
      }
    }
    .option.selected .dot {
      background-color: $primary;
    }

    #payment_options,
    #wallets {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;

      .option {
        flex: 1 1 140px;
      }
    }
    #payment_options .icon {
      width: 20px; // fits the 55px option's content box
      height: 20px;
      margin: 0 0 0 auto; // push to the right edge; dot + label stay left
    }
    #wallets .option {
      display: flex;
      justify-content: flex-start;
      height: 80px;

      img {
        height: 40px;
        // width: 40px;
        aspect-ratio: 1;
        object-fit: contain;
        margin: 0;
      }
    }

    #save {
      background-color: $primary;
      color: $white;
      width: 100%;
      height: 56px;
      border: 0;
      border-radius: 16px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: -0.01em;
      cursor: pointer;
      margin-top: 0.5rem;

      &:hover {
        background-color: $primary-dark;
      }
    }
  }
}

@media screen and (max-width: 450px) {
  #configPage form {
    padding: 20px;

    #payment_options .option,
    #wallets .option {
      flex-basis: 100%;
    }
  }
}
</style>
